import * as React from 'react';
import { Dispatch } from 'redux';
import { EventVideoViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventVideoNormalizers from '../normalizers/eventVideoNormalizers';

export class GetAllEventVideosRequest extends BaseApiGetRequest<
  EventVideoViewModel,
  EntityNormalizers.NormalizedEntityArray<EventVideoNormalizers.NormalizedEventVideos>
> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events/${eventId}/event-videos`;
    this.normalizeMethod = EventVideoNormalizers.normalizeEventVideosArray;
  }
}
